module.exports = __webpack_public_path__ + "static/media/face2a.2c1d100b.jpg";